import { STEP_ORDER, type OnboardingStepId } from "@/stores/onboardingStore";

interface StepDotsProps {
  current: OnboardingStepId;
  /** Steps to exclude from the dots (e.g. "done" after success). */
  hide?: OnboardingStepId[];
}

/**
 * Minimal progress dots shown in the onboarding footer.
 *
 * The active dot grows into a short bar; finished dots stay small and
 * tinted; upcoming dots are neutral. No numbers, no labels — the step
 * title carries the "where am I" information.
 */
export function StepDots({ current, hide = [] }: StepDotsProps) {
  const steps = STEP_ORDER.filter((s) => !hide.includes(s));
  const currentIdx = steps.indexOf(current);

  return (
    <div className="flex items-center gap-2" aria-label="Onboarding progress">
      {steps.map((id, idx) => {
        const isDone = idx < currentIdx;
        const isActive = idx === currentIdx;
        return (
          <span
            key={id}
            className={`block h-1.5 rounded-full transition-all duration-300 ease-out
              ${isActive ? "w-6 bg-jove" : isDone ? "w-1.5 bg-jove/60" : "w-1.5 bg-space-30"}`}
            aria-current={isActive ? "step" : undefined}
          />
        );
      })}
    </div>
  );
}
